module.exports = __webpack_public_path__ + "static/img/animation-index6.c20ba0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/animation-index6.png
// module id = y6CV
// module chunks = 4